import React, { useEffect, useState } from 'react';
import { Check, Clock, Tag, ChevronRight } from 'lucide-react';

const Prices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch('https://api.dev.auxo.dk/public/content/services');
        const data = await response.json();
        setServices(data);
      } catch (error) {
        console.error('Error fetching services:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-amber-500"></div>
      </div>
    );
  }

  // Group services by category
  const categories = services.reduce((acc, service) => {
    const cat = service.category?.da || 'Andet';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(service);
    return acc;
  }, {});

  return (
    <div className="pt-64 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="text-center mb-16">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-prata font-medium text-stone-900 mb-4 uppercase tracking-tight">
            Vores Priser
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Find den rette behandling til dine behov. Vi tilbyder alt fra afslappende massage til dybdegående kropsbehandlinger.
          </p>
        </div>

        {Object.entries(categories).map(([category, items]) => (
          <div key={category} className="mb-20">
            <h2 className="text-2xl font-prata font-medium text-stone-900 mb-8 pb-2 border-b border-stone-200 uppercase tracking-tight">
              {category}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {items.map((service) => (
                <div 
                  key={service.id}
                  className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col justify-between"
                >
                  <div>
                    <div className="flex justify-between items-start mb-4">
                      <h3 className="text-xl font-prata font-medium text-stone-900 uppercase tracking-wide">
                        {service.title.da}
                      </h3>
                      <span className="text-black font-bold text-lg whitespace-nowrap ml-4">
                        {service.price} kr.
                      </span>
                    </div>
                    
                    <div 
                      className="text-stone-600 mb-6 prose prose-sm max-w-none"
                      dangerouslySetInnerHTML={{ __html: service.description.da }}
                    />
                  </div>
                  
                  <div className="mt-auto">
                    <div className="flex items-center text-sm text-stone-500 gap-4 mb-6 pt-6 border-t border-stone-50">
                      <div className="flex items-center">
                        <Clock className="w-4 h-4 mr-1 text-stone-400" />
                        {service.duration.da}
                      </div>
                      <div className="flex items-center">
                        <Tag className="w-4 h-4 mr-1 text-stone-400" />
                        {category}
                      </div>
                    </div>

                    <a 
                      href="/kontakt"
                      className="text-sm font-bold text-[#b0a697] hover:text-[#9a8f7d] transition-colors uppercase tracking-widest flex items-center justify-center py-3 border border-[#b0a697]/20 rounded-lg hover:bg-[#b0a697]/5 w-full"
                    >
                      Bestil tid
                      <ChevronRight className="w-4 h-4 ml-1" />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Prices;
